import * as React from "react";

const bgmarkTemplate = (props) => {
  let widthval = "70%";
  const dynamicval = props.data;
  if (dynamicval === undefined) {
    widthval = "70%";
  } else {
    widthval = dynamicval;
  }
  return (
    <div
      className="row"
      style={{
        position: "absolute",
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        left: "0px",
        top: "0px",
        bottom: "0px",
        margin: "0 auto",
        width: "100%"
      }}
    >
      <img
        src={require("Assets/img/tsga-letterhead-watermark.png")}
        className="img-fluid"
        alt=""
        style={{
          backgroundRepeat: "no-repeat",
          margin: "0 auto",
          width: widthval,
          userSelect: "none"
        }}
      />
    </div>
  );
};

export default bgmarkTemplate;
